const jobActionOrigins = [
  'cardTitle',
  'jobCard',
  'showNewTab',
  'jobTitle',
  'stickyTitle',
] as const;
export type JobActionOrigin = (typeof jobActionOrigins)[number];

export const getJobActionOrigin = (origin?: JobActionOrigin) => ({
  jobActionOrigin:
    origin && jobActionOrigins.includes(origin) ? origin : 'NULL',
});
